<template>
  <div>
    <Main
      ref="main"
      :disabled="disabled"
      :loading="loading"
      @change="(e) => $emit('change', e)"
    >
      <template #header>
        <div class="side-frame-success" style="display: inline-block;">
          <span style="font-size: 14px; color: #606266">
            {{ $l('sku-reply-table_label') || '工厂库存信息' }}
          </span>
        </div>
        <el-button
          type="primary"
          size="mini"
          class="ml-2"
          plain
          @click="reloadInv()"
        >
          {{ $l('btn_reloadInv') || '刷新库存' }}
        </el-button>
        <el-button type="success" size="mini" plain @click="getData()">
          {{ $l('btn_resetReply') || '重置数据' }}
        </el-button>
      </template>
    </Main>
  </div>
</template>

<script>
import Main from './main'
import BaseTable from '@/mixins/base-table'
import { multiply, divideDown } from '@/libs/util.number.js'
export default {
  mixins: [BaseTable],
  components: { Main },
  props: {
    disabled: { type: Boolean, default: false },
    amzReplenishmentDetailCode: { type: String, default: '' },
  },
  data() {
    return { loading: false }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyDataApi({
          amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
        })
        .catch(() => null)
      this.loading = false

      const tableData = res?.body?.data || []
      this.$refs.main.reloadData(tableData)
    },
    async getOptions() {
      if (!this.amzReplenishmentDetailCode) return []
      const params = {
        amzReplenishmentDetailCode: this.amzReplenishmentDetailCode,
      }
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyOptionsApi(params)
        .catch(() => null)

      const data = res?.body?.data || []
      return data.map((item) => {
        const { ecomWarehouseCode, ecomWarehouseName } = item
        return {
          ...item,
          displayEcomWarehouseCode: ecomWarehouseCode,
          displayEcomWarehouseName: ecomWarehouseName,
        }
      })
    },
    async reloadInv() {
      this.loading = true

      const data = await this.getOptions()
      if (!data?.length) return (this.loading = false)

      const $main = this.$refs.main
      const tableData = await this.getTableData()

      const getRowKey = (row) => {
        return [
          row.ncNo,
          row.scmCode,
          row.ecomWarehouseCode,
          row.inCtnQty,
          row.amzPurchaseNo,
          row.ftyPrice,
        ]
          .filter(Boolean)
          .join()
      }

      const newTableData = data.map((newRow) => {
        const newRowKey = getRowKey(newRow)
        const oldRow = tableData.find((row) => getRowKey(row) === newRowKey)
        const row = { ...newRow, ...(oldRow || {}) }

        const { inCtnQty, qty } = row
        const ctnQty = divideDown(qty, inCtnQty, 0)
        const tailQty = qty - multiply(inCtnQty, ctnQty)
        const tailCtnQty = tailQty ? 1 : 0
        
        row.tailQty = tailQty
        row.ctnQty = ctnQty
        row.tailCtnQty = tailCtnQty
        row.totalCtnQty = ctnQty + tailCtnQty
        return row
      })

      $main.reloadData(newTableData)
      this.loading = false
    },
    async validate() {
      const tableData = await this.getTableData()
      if (!tableData?.length) {
        this.$message.error(
          this.$l('tips_skuNoWhInv') || '该SKU无库存信息，无法补货'
        )
        return false
      }

      const result = await this.$refs.main.validate()
      if (!result) return false
      const validateData = await this.getValidateTableData()
      if (!validateData?.length) {
        this.$message.error(this.$l('tips_editReplyInfo') || '请填写返答数量')
        return false
      }
      return true
    },
    async getTableData() {
      const tableData = await this.$refs.main.getTableData()
      if (!tableData?.length) return []
      return tableData.map((item) => ({
        ...item,
        poNo: item.amzPurchaseNo || '',
      }))
    },
    async getValidateTableData() {
      const tableData = await this.getTableData()
      if (!tableData?.length) return []
      return tableData.filter((item) => !!item.qty)
    },
  },
}
</script>
